import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function usePreventBack() {
  const history = useHistory();
  const { t }=useTranslation();
  
  useEffect(() => {


    // Ajoute une entrée factice dans l'historique
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      const confirmed = window.confirm(
        t("warningIfYouGoBackYouLoseCurrentSession")
      );

      if (confirmed) {
        // autoriser le vrai back
        history.goBack();
      } else {
        // rester ici : recrée un état historique
        window.history.pushState(null, "", window.location.href);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [ t, history]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {

      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener(
        "beforeunload",
        handleBeforeUnload
      );
    };
  }, []);
}

export default usePreventBack;